<template>
  <div ref="dom" class="charts chart-bar"></div>
</template>

<script>
import * as echarts from 'echarts'
import { on, off } from '@/libs/tools'

export default {
  name: 'ChartBar',
  props: {
    value: Object,
    text: String,
    subtext: String,
    x: [],
    y: []
  },
  data () {
    return {
      dom: null
    }
  },
  methods: {
    resize () {
      this.dom.resize()
    },
    updateData (data) {
      this.value = data
      this.initXY()
    },
    updateSeriesData (x, y) {
      this.initData(x, y)
    },
    initXY () {
      if (this.value) {
        this.x = Object.keys(this.value)
        this.y = Object.values(this.value)
      }
      this.initData(this.x, this.y)
    },
    initData (xAxisData, seriesData) {
      let option = {
        title: {
          text: this.text,
          subtext: this.subtext,
          x: 'center'
        },
        xAxis: {
          type: 'category',
          data: xAxisData
        },
        yAxis: {
          type: 'value'
        },
        series: [{
          data: seriesData,
          type: 'bar',
          label: {
            show: true,
            position: 'top',
            textStyle: {
              color: '#555'
            }
          }
        }]
      }
      this.dom = echarts.init(this.$refs.dom, 'tdTheme')
      this.dom.setOption(option)
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.initXY()
      on(window, 'resize', this.resize)
    })
  },
  beforeDestroy () {
    off(window, 'resize', this.resize)
  }
}
</script>
